
import { useState } from "react";
import { useFixedJobSearch } from "@/hooks/useFixedJobSearch";
import { TeacherScheduleSearch } from "./TeacherScheduleSearch";
import { TeacherScheduleTable } from "./TeacherScheduleTable";

export function TeacherSchedule() {
  const [selectedTeacher, setSelectedTeacher] = useState<{ code: string; name: string } | undefined>();
  const { fixedJobs, isLoading } = useFixedJobSearch(selectedTeacher?.code);

  return (
    <div className="container mx-auto py-6">
      <h1 className="text-2xl font-bold mb-6">ตารางสอนครู</h1>
      
      <TeacherScheduleSearch onSelectTeacher={setSelectedTeacher} />
      
      {selectedTeacher ? (
        <TeacherScheduleTable fixedJobs={fixedJobs} isLoading={isLoading} />
      ) : (
        <div className="bg-muted/50 p-8 rounded-lg text-center">
          กรุณาค้นหาครูเพื่อดูตารางสอน
        </div>
      )}
    </div>
  );
}
